import { constants } from '@config';
import { getSelectedCoordinates } from 'src/utils/coordinate';

export default class Gesture {
  constructor (canvas) {
    _.extend(this, Backbone.Events);
    this.dblClickTimeout = null;
    this.isDblClick = false;
    this.canvas = canvas;

    this.handler = null;

    // animation
    this.isAnimated = false;

    this.touchDistance = 0;
    this.touchX = 0;
    this.touchY = 0;
    this.initialZoom = canvas.getZoom();
    this.finalZoom = this.initialZoom;
    this.canvasSize = null;
    this.selectedTableCell = null;

    const that = this;
    let startsInWorkarea = false;

    let firstTouchTime;
    let lastTouchTime;
    let lastTouchElem;
    let lastTouchCoords;
    let previousElemForDoubleTap;
    let currKey;

    // prevent links from being followed in the canvas
    function handleLinkInCanvas (e) {
      e.preventDefault();
      return false;
    }

    function mouseDown (event) {
      startsInWorkarea = true;

      if (event.button === 1 || that.canvas.spaceKey || currKey === ' ' || currKey === 'Space') {
        return;
      }

      event.preventDefault();

      that.onTouch(event, event.pageX, event.pageY);
    }

    function mouseMove (event) {
      if (event.button === 1 || that.canvas.spaceKey || currKey === ' ' || currKey === 'Space') {
        return;
      }

      if (event.button === 2) {
        return;
      }
      event.preventDefault();
      that.onMove(event, event.pageX, event.pageY, () => {});
    }

    function mouseUp (event) {
      if (!startsInWorkarea || event.button === 2) {
        return;
      }

      startsInWorkarea = false;
      that.onTouchEnd(event, event.pageX, event.pageY);
    }

    function mouseenter (event) {
      const elementTarget = event.target.closest('.element');

      canvas.runExtensions('mouseEnter', {
        event,
        element: elementTarget,
        selectedElements: canvas.getSelectedElems()
      }, true);
    }

    function mouseleave (event) {
      const elementTarget = event.target.closest('.element');

      canvas.runExtensions('mouseLeave', {
        event,
        element: elementTarget
      }, true);
    }

    function onDblClick (event) {
      that.onDblClick(event, event.pageX, event.pageY);
    }

    function getTouchDistance (eventTouches) {
      const a = eventTouches[0].pageX - eventTouches[1].pageX;
      const b = eventTouches[0].pageY - eventTouches[1].pageY;

      return Math.sqrt(a * a + b * b);
    }

    function adjustPreviousElem () {
      if (!INKIVE.C.IS_MOBILE) {
        return;
      }
      const selectedElements = canvas.getSelectedElems();

      previousElemForDoubleTap = selectedElements.length === 1 ? selectedElements[0] : null;
    }

    const designEvents = ['logo.create', 'logo.update', 'icon.create', 'text.update', 'group.create', 'image.create',
      'shape.create', 'sticker.create', 'text.create', 'duplicate'];

    _.each(designEvents, function (eventName) {
      INKIVE.DesignFacade.on(eventName, adjustPreviousElem);
    });

    INKIVE.EditorFacade.on('deselect_all', adjustPreviousElem);

    function touch (event) {
      let x;
      let y;

      const now = new Date();
      const doubleClickInterval = 500;
      const doubleClickMovement = 20;
      event.preventDefault();

      const $selectorParentGroup = $('#selectorParentGroup');
      const selectedElements = canvas.getSelectedElems();
      const selectedElement = selectedElements.length === 1 ? selectedElements[0] : null;
      const isBackground = $(selectedElement).parent().is('.background');

      const eventTouches = _.filter(event.touches, function (touch) { return touch; });

      switch (event.type) {
        case 'touchstart':
          $selectorParentGroup.removeClass('hidden');
          if (eventTouches.length === 1) {
            canvas.setMode('select');
            x = event.changedTouches[0].pageX;
            y = event.changedTouches[0].pageY;
            if (lastTouchElem !== event.target || (firstTouchTime && now - lastTouchTime > doubleClickInterval)) {
              event.target.matches('svg#svgroot') && selectedElement && canvas.clearSelection();
              firstTouchTime = null;
              lastTouchTime = now;
            } else if (lastTouchElem === event.target) {
              firstTouchTime = lastTouchTime;
              lastTouchTime = now;
            }

            lastTouchElem = event.target;
            lastTouchCoords = {
              x,
              y
            };
            that.onTouch(event, x, y, previousElemForDoubleTap);
          } else { // Multitouch
            canvas.clearSelection();
            that.handler = new INKIVE.GestureScroll(canvas);

            const svgPanel = canvas.getSvgPanel();

            if (svgPanel) svgPanel.style.display = 'none';

            const rootScreenCTM = svgPanel.querySelector('g#selectorParentGroup').getScreenCTM().inverse();
            const pt = svgedit.math.transformPoint(eventTouches[0].pageX, eventTouches[0].pageY, rootScreenCTM);
            const mouseTarget = canvas.getMouseTarget(event, pt);

            x = (eventTouches[0].pageX + eventTouches[1].pageX) / 2;
            y = (eventTouches[0].pageY + eventTouches[1].pageY) / 2;

            canvas.setMode('zooming');
            that.handler.init(x, y, mouseTarget, false, event);

            $('.antiscroll-scrollbar').removeClass('antiscroll-scrollbar-shown');
            that.touchDistance = getTouchDistance(eventTouches);
            that.initialZoom = canvas.getZoom();
            that.canvasSize = Math.sqrt(canvas.contentW * canvas.contentW + canvas.contentH * canvas.contentH);
            that.fitZoom = Math.min(parseInt(this.style.width) / canvas.contentW, parseInt(this.style.height) / canvas.contentH);

            that.dblClickTimeout = null;
            firstTouchTime = null;
          }

          break;

        case 'touchmove':
          if (eventTouches.length === 1) {
            if (firstTouchTime) {
              const diffX = lastTouchCoords.x - event.changedTouches[0].pageX;
              const diffY = lastTouchCoords.y - event.changedTouches[0].pageY;
              const diff = diffX * diffX + diffY * diffY;

              if (diff > doubleClickMovement) firstTouchTime = null;
            }

            that.onMove(event, event.changedTouches[0].pageX, event.changedTouches[0].pageY);
          } else { // Multitouch
            if (canvas.getSelectedElems()[0] && !isBackground && that.isMovementAllowed) {
              const distance = getTouchDistance(eventTouches);

              canvas.current_resize_mode = 'ne-center';
              that.onMove(event, that.touchX + (distance - that.touchDistance),
                that.touchY + (distance - that.touchDistance));
            } else {
              const touchEnd = getTouchDistance(eventTouches);

              const zoomMobileFactor = constants.mobile.zoomFactor;
              const zoomMin = INKIVE.C.IS_MOBILE ? Math.max(that.fitZoom * zoomMobileFactor, 0.1) : 0.1;
              const zoomMax = 5;

              const touchStart = that.touchDistance;
              const touchMax = that.canvasSize;

              const percent = (touchEnd - touchStart) / (touchMax - touchStart);
              that.finalZoom = percent * (zoomMax - that.initialZoom) + that.initialZoom;
              if (that.finalZoom < zoomMin) {
                that.finalZoom = zoomMin;
              }

              canvas.setZoom(that.finalZoom);

              x = (eventTouches[0].pageX + eventTouches[1].pageX) / 2;
              y = (eventTouches[0].pageY + eventTouches[1].pageY) / 2;

              that.handler.update(x, y, event);
            }
          }
          break;

        case 'touchend':
        case 'touchcancel':
          if (canvas.getMode() === 'zooming') {
            const svgPanel = canvas.getSvgPanel();

            canvas.rubberBox?.setAttribute('width', 0);
            canvas.rubberBox?.setAttribute('height', 0);

            if (svgPanel) svgPanel.style.display = '';
            canvas.setMode('select');
            canvas.call('editor.zoomChanged', that.finalZoom);
          }

          if (event.changedTouches && event.changedTouches.length) {
            x = event.changedTouches[0].pageX;
            y = event.changedTouches[0].pageY;
          }

          that.onTouchEnd(event, x, y);
          that.isMultiTouch = false;

          if (event.type === 'touchend' && firstTouchTime && now - firstTouchTime < doubleClickInterval) {
            that.onDblClick(event, x, y);
          }

          previousElemForDoubleTap = $(selectedElement).parent().is('.background') ? null : selectedElement;

          $selectorParentGroup.removeClass('hidden');
          break;
      }
    }

    // Touch
    const workArea = canvas.getWorkarea();

    workArea.addEventListener('touchstart', touch, true);
    workArea.addEventListener('touchmove', touch, true);
    workArea.addEventListener('touchend', touch, true);
    workArea.addEventListener('touchcancel', touch, true);

    $(workArea).mousedown(mouseDown).dblclick(onDblClick);
    $(workArea).mousemove(mouseMove).click(handleLinkInCanvas);
    $(document).mouseup(mouseUp);
    $(document).on('mouseenter', '.table.element', mouseenter);
    $(document).on('mouseleave', '.table.element', mouseleave);

    window.addEventListener('keydown', (event) => { currKey = event.key; });
    window.addEventListener('keyup', () => { currKey = null; });
  }

  testResize (elem, isDecrease) {
    function rotate (cx, cy, x, y, angle) {
      const radians = (Math.PI / 180) * angle;
      const cos = Math.cos(radians);
      const sin = Math.sin(radians);
      const nx = (cos * (x - cx)) + (sin * (y - cy)) + cx;
      const ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
      return {
        x: nx,
        y: ny
      };
    }

    function getMidPoint (x, y, width, height, angleDegrees) {
      const angleRad = angleDegrees * Math.PI / 180;
      const cosa = Math.cos(angleRad);
      const sina = Math.sin(angleRad);
      const wp = width / 2;
      const hp = height / 2;
      return {
        x: (x + wp * cosa - hp * sina),
        y: (y + wp * sina + hp * cosa)
      };
    }

    elem = $(elem)[0];
    const that = this;
    const bbox = elem.getBoundingClientRect();

    const angle = that.canvas.getRotationAngle(elem);

    const $selector = $(that.canvas.getSvgPanel()).find('g#selectorParentGroup');
    const dot = $selector.find('#selectorGrip_resize_ne')[0].getBoundingClientRect(0);
    const mid = getMidPoint(dot.left, dot.top, dot.width, dot.height, angle);
    const x = mid.x;
    const y = mid.y;

    const delta = bbox.width * 0.1;
    // const delta = 10;
    const a = (isDecrease ? 180 : 0) - angle;
    const coords = rotate(0, 0, delta, 0, a);

    const dx = x + coords.x;
    const dy = y + coords.y;

    this.canvas.current_resize_mode = 'ne';
    this.canvas.setMode('resize');

    this.onTouch({ target: elem }, x, y);
    this.onMove({ target: elem }, dx, dy, function () {
      that.onTouchEnd({ target: elem }, dx, dy);
    });
  }

  onDblClick (event, x, y) {
    const that = this;
    const canvas = that.canvas;

    if (_.contains(['plus', 'minus'], canvas.current_resize_mode)) return;
    if (localStorage.getItem('lock_elements') === 'true') {
      canvas.call('advice.show', 'global-locked');
      return;
    }
    const pt = svgedit.math.transformPoint(x, y, that.root_sctm);
    const mouseTarget = canvas.getMouseTarget(event, pt);// || this.target;
    // if(!mouseTarget) return;
    // this.target = mouseTarget;

    canvas.runExtensions('dblClick', {
      event,
      mouse_target: mouseTarget,
      mouse_x: pt.x,
      mouse_y: pt.y,
      is_click_inside: INKIVE.Tool.getInstance().editor.isClickInsideEditor(x, y)
    });
    this.trigger('double_click', event);

    that.isAnimated = false;
  }

  onTouch (event, x, y, previousElemForDoubleTap) {
    const that = this;
    const canvas = that.canvas;
    const isTempCanvas = event.target.classList.contains('screenshot-temp-canvas');

    if (localStorage.getItem('lock_elements') === 'true') {
      canvas.call('advice.show', 'global-locked');
      return;
    }

    if (isTempCanvas) return;

    checkDoubleClick();

    event.altKey && canvas.cloneSelectedElements(0, 0);
    that.root_sctm = $(canvas.getSvgPanel()).find('g#selectorParentGroup')[0].getScreenCTM().inverse();

    const pt = svgedit.math.transformPoint(x, y, that.root_sctm);
    const mouseX = pt.x;
    const mouseY = pt.y;

    const isRightClick = (
      event.button === 2 ||
      $(event.target).is('#context-menu-layer')
    );

    if (isRightClick) {
      ['textedit', 'table-edit'].includes(canvas.getMode()) || canvas.setMode('select');
      canvas.lastClickPoint = pt;
      INKIVE.ContextMenu.handleContextMenu(event);
      return;
    }

    const selectedElements = _.toArray(canvas.getSelectedElems());
    const selectedElement = selectedElements[0];

    const isTableCell = selectedElements.length === 1 && selectedElement?.parentElement?.classList.contains('table-cell');
    const stop = isTableCell && canvas.getMode() === 'textedit' ? selectedElement.parentElement : null;

    let mouseTarget = canvas.getMouseTarget(event, pt, stop);
    if (!mouseTarget) {
      return;
    }
    const $subelement = $(event.target).closest('.subelement');

    if ($('#layoutScreen').length) {
      const isInteractingWithImage = $(mouseTarget).is('.layoutClipperImage');
      const isInteractingWithGrips = !!$(mouseTarget).closest('#selectorParentGroup').length;

      if (!isInteractingWithImage && !isInteractingWithGrips) {
        return;
      }
    }

    mouseTarget.classList.remove('highlighted');

    $(mouseTarget).contents().each(function () {
      $(this).is('.subelement.active') && $(this).removeClass('active');
    });

    if ($subelement.length && $.contains(mouseTarget, $subelement[0])) {
      $subelement.addClass('active');
      canvas.call('editor.sub_selected', [$subelement[0]]);
    } else {
      canvas.call('editor.elem_selected', [mouseTarget]);
    }

    if (mouseTarget.tagName === 'a' && mouseTarget.childNodes.length === 1) {
      mouseTarget = mouseTarget.firstChild;
    }

    // if it is a selector grip, then it must be a single element selected,
    // set the mouse_target to that and update the mode to rotate/resize
    if ((canvas.getMode() === 'select' || canvas.getMode() === 'table-edit') &&
      mouseTarget === canvas.selectorManager.selectorParentGroup &&
      canvas.getSelectedElems()[0] != null) {
      const grip = event.target && event.target.nodeName ? event.target : event.target.correspondingUseElement;

      const griptype = $.data(grip, 'type');
      // rotating
      if (griptype === 'rotate') {
        canvas.setMode('rotate');
      } else if (griptype === 'resize' || _.include(['plus', 'minus'], griptype)) { // resizing
        canvas.setMode('resize');
        canvas.current_resize_mode = $.data(grip, 'dir') || griptype;
      } else if (griptype === 'move') {
        canvas.setMode('select');
      }

      mouseTarget = canvas.getSelectedElems()[0];
    }

    if (event.target.closest('#table-grip')) {
      return;
    }

    canvas.startTransform = mouseTarget.getAttribute('transform');

    const isSameTable = mouseTarget?.closest('.table') === selectedElements[0]?.closest('.table');
    const isNewTableCellSelected = isSameTable && canvas.getMode() === 'table-edit' && mouseTarget?.closest('.table') && !this.selectedTableCell;
    const isTableBorderEditor = event.target?.closest('.table-border-editor');
    isNewTableCellSelected && !isTableBorderEditor && !event.shiftKey && canvas.setMode('select');

    switch (canvas.getMode()) {
      case 'multiselect':
      case 'select':
        that.handler = new INKIVE.GestureMove(canvas);
        break;
      case 'rotate':
        that.handler = new INKIVE.GestureRotate(canvas);
        break;
      case 'resize':
        that.handler = new INKIVE.GestureResize(canvas);
        break;
      default:
        that.handler = new INKIVE.GestureDraw(canvas);
    }

    let handledElement = mouseTarget;
    if (event.touches && event.touches.length > 1 && (canvas.getMode() === 'resize')) {
      handledElement = selectedElements[0];
    }

    that.handler.init(mouseX, mouseY, handledElement, isRightClick, event);

    that.isDblClick && that.handler.update(mouseX, mouseY, event, that.isDblClick);

    if (_.contains(['plus', 'minus'], canvas.current_resize_mode)) {
      _.delay(resizeButtonHandler, 50);
      return;
    }

    const extResult = canvas.runExtensions('mouseDown', {
      event,
      mouse_target: mouseTarget,
      start_x: that.handler.start_x,
      start_y: that.handler.start_y,
      mouse_x: mouseX,
      mouse_y: mouseY,
      selectedElements: canvas.getSelectedElems(),
      prevElemDoubleTap: previousElemForDoubleTap,
      prevElements: selectedElements
    }, true);

    that.isMovementAllowed = isMovementAllowed();

    if (isScroll()) {
      that.handler.destruct();
      that.handler = new INKIVE.GestureScroll(canvas);
      that.handler.init(mouseX, mouseY, mouseTarget, isRightClick, event.shiftKey);
      that.isMovementAllowed = canvas.started = true;
    } else if (that.isMovementAllowed) {
      $.each(extResult, function (i, r) {
        if (r && r.started) {
          canvas.started = true;
        }
      });
    }

    that.isAnimated = false;

    const selectedElems = canvas.getSelectedElems();
    if (selectedElems.length) {
      switch (canvas.getMode()) {
        case 'select':
          INKIVE.EditorFacade.trigger('move.start', { element_id: selectedElems[0]?.id });
          break;
        case 'resize':
          INKIVE.EditorFacade.trigger('resize.start', { element_id: selectedElems[0]?.id });
          break;
        case 'rotate':
          INKIVE.EditorFacade.trigger('rotate.start', { element_id: selectedElems[0]?.id });
          break;
      }
    }

    function isMovementAllowed () {
      return !INKIVE.C.IS_MOBILE_APP ||
        canvas.getMode() !== 'select' ||
        isSameSelection() ||
        isScrollBarHidden();
    }

    function isScroll () {
      return INKIVE.C.IS_MOBILE_APP &&
        $('#ik-editor > .antiscroll-scrollbar').length &&
        (canvas.getMode() === 'select' || canvas.getMode() === 'multiselect') &&
        (!selectedElements.length || !isSameSelection());
    }

    function isSameSelection () {
      const currentElems = _.toArray(canvas.getSelectedElems());

      return currentElems.length === selectedElements.length &&
        _.all(currentElems, function (elem1) {
          return _.any(selectedElements, function (elem2) {
            return elem1?.getAttribute('id') === elem2?.getAttribute('id');
          });
        });
    }

    function isScrollBarHidden () {
      const workarea = $('#workarea')[0];
      return workarea.clientHeight === workarea.scrollHeight && workarea.clientWidth === workarea.scrollWidth;
    }

    function resizeButtonHandler () {
      const dimensions = handledElement.getBoundingClientRect();
      const canDecrease = (dimensions.height > 3 && dimensions.width > 3) || canvas.current_resize_mode === 'plus';

      if (canDecrease) {
        that.handler.update(mouseX, mouseX, event);
        _.delay(function () {
          canvas.current_resize_mode = 'none';
          that.handler.destruct();
        }, 50);
      }
    }

    function checkDoubleClick () {
      that.isDblClick = false;

      if (that.dblClickTimeout) {
        clearTimeout(that.dblClickTimeout);
        that.isDblClick = true;
        that.dblClickTimeout = null;
      }

      if (!that.isDblClick) {
        that.dblClickTimeout = _.delay(function () {
          that.isDblClick = false;
          that.dblClickTimeout = null;
        }, 200);
      }
    }
  }

  onMove (event, x, y, callback) {
    callback = callback || $.noop;

    const that = this;
    const canvas = that.canvas;
    const rf = INKIVE.RestrictionsFacade;
    const selected = canvas.getSelectedElems()[0];
    const allSelected = INKIVE.EditorFacade.selectedElements;
    let isLocked = false;

    this.handleOutline(event.target);
    this.selectedTableCell = event.target?.closest('.table-cell-selected');

    if (_.contains(['plus', 'minus'], canvas.current_resize_mode)) return;

    if (canvas.started && !that.isAnimated && that.isMovementAllowed) {
      if (canvas.getMode() === 'select') {
        const hasPositionRestrictedElement = allSelected.some(element => !rf.canChange(element, 'position'));

        const cantMove = (hasPositionRestrictedElement && !$(selected).hasClass('layoutClipperImage')) ||
          $(selected).is('.non-selectable');
        if (cantMove) {
          return;
        }
      }

      if (canvas.getMode() === 'resize') {
        if (!rf.canChange(selected, 'size') && !$(selected).hasClass('layoutClipperImage')) {
          return;
        }
      }

      if (canvas.getMode() === 'rotate') {
        if (!rf.canChange(selected, 'rotation')) return;
      }

      if (allSelected.length > 1 && canvas.getMode() !== 'multiselect') {
        for (const element of allSelected) {
          if (element.classList.contains('locked')) {
            isLocked = true;
            break;
          }
        }
      }

      isLocked = $(selected).is('.locked') || isLocked;

      if (isLocked && canvas.getMode() !== 'multiselect') {
        isLocked ? canvas.call('advice.show', 'locked-element') : canvas.call('advice.show', 'locked-element');

        if ($(selected).hasClass('layoutBox')) {
          that.onTouchEnd(event, x, y);
        } else {
          return;
        }
      }

      window.requestAnimationFrame(function () {
        if (canvas.started) {
          const pt = svgedit.math.transformPoint(x, y, that.root_sctm);
          const mouseX = pt.x;
          const mouseY = pt.y;

          const retval = that.handler.update(mouseX, mouseY, event) || [];

          if (!retval) {
            return;
          }

          const mouseTarget = canvas.getMouseTarget(event, pt);

          canvas.runExtensions('mouseMove', {
            event,
            mouse_target: mouseTarget,
            mouse_x: mouseX,
            mouse_y: mouseY,
            start_x: that.handler.start_x,
            start_y: that.handler.start_y,
            dx: retval[0], // dx
            dy: retval[1], // dy
            selected: canvas.getSelectedElems()
          });

          callback();
        }

        that.isAnimated = false;
      });

      that.isAnimated = true;
    }
  }

  processRotationCenter (selected) {
    const tlist = svgedit.transformlist.getTransformList(selected);
    const listLength = tlist?.numberOfItems || 0;

    for (let i = 0; i < listLength; i++) {
      const transform = tlist.getItem(i);

      if (transform.type === 4) {
        recalculateRotationCenter.call(this, transform);
        break;
      }
    }

    function recalculateRotationCenter (transform) {
      const zoom = this.canvas.getZoom();
      const oldCenter = getCenterPosition();
      this.canvas.setRotationAngle(transform.angle, true);
      const newCenter = getCenterPosition();

      this.canvas.moveSelectedElements(
        (oldCenter.x - newCenter.x) * zoom,
        (oldCenter.y - newCenter.y) * zoom
      );
    }

    function getCenterPosition () {
      const box = svgedit.utilities.getBBox(selected);
      const cx = box.x + box.width / 2;
      const cy = box.y + box.height / 2;
      const m = svgedit.math.getMatrix(selected);
      const center = svgedit.math.transformPoint(cx, cy, m);

      return {
        x: center.x,
        y: center.y
      };
    }
  }

  processClipPathResize (selected) {
    const clipPath = svgedit.utilities.getClipPath(selected);
    if (!clipPath) return [];

    return [...clipPath.childNodes]
      .map(svgedit.recalculate.recalculateDimensions);
  }

  isClippathResize (selected) {
    return $(selected).hasClass('layoutBox') && isCropMode.call(this);

    function isCropMode () {
      const m = this.canvas.current_resize_mode;
      return m === 'e' || m === 'w' || m === 'n' || m === 's';
    }
  }

  processImageResize (selected) {
    const canvas = this.canvas;
    const isImage = INKIVE.DesignFacade.getType(selected) === 'image';
    const isClipper = INKIVE.DesignFacade.getType(selected) === 'imageclipper';

    if (!isImage && !isClipper) return;

    const id = isClipper
      ? selected.getAttribute('data-old-id') || selected.getAttribute('id')
      : selected.getAttribute('id');
    const dirtyImage = document.querySelector('#svgroot image#' + id);
    const isVideo = INKIVE.DesignFacade.getType(dirtyImage.parentElement) === 'video';

    if (!dirtyImage || isVideo) return;

    const isDataUrl = INKIVE.Helpers.isDataURL(selected.getAttribute('xlink:href'));
    if (isDataUrl) return;

    const savedImageVersion = INKIVE.ImagesFactory.getImageUrl(selected) || selected.getAttribute('xlink:href');
    const inOrderLoadOptions = INKIVE.Image.Helpers.getInOrderLoadOptions(savedImageVersion, {
      width: selected.getAttribute('width'),
      height: selected.getAttribute('height')
    });

    INKIVE.Image.Helpers.loadImageOptions(inOrderLoadOptions, function (img) {
      const data = { source: { url: img.src, smart_load: false, skip_thumbnail: true } };
      INKIVE.DesignFacade.set(id, _.extend(data, { skipHistory: true }));

      canvas.runExtensions('fixImageSize', {
        elem: selected,
        skipSelection: true
      });
    });
  }

  onTouchEnd (event, x, y) {
    if (event.touches && event.touches.length > 1) return;
    const that = this;
    const canvas = this.canvas;
    const isClickInside = INKIVE.Tool.getInstance().editor.isClickInsideEditor(x, y);
    let _retval = null;

    if (_.contains(['plus', 'minus'], canvas.current_resize_mode)) return;

    const canvasMode = canvas.getMode();
    const selectedElems = canvas.getSelectedElems() || [];
    const selected = selectedElems[0];

    if (canvasMode === 'select' || canvasMode === 'multiselect') {
      if (selectedElems.length) {
        canvasMode === 'multiselect' && canvas.call('editor.selected', selectedElems);
        INKIVE.EditorFacade.trigger('move.end');
      }
    } else if (canvasMode === 'rotate') {
      INKIVE.EditorFacade.trigger('rotate.end', { element_id: selected.id });
    } else if (canvasMode === 'resize') {
      const isClipPathresize = this.isClippathResize(selected);

      _retval = isClipPathresize
        ? this.processClipPathResize(selected)
        : svgedit.recalculate.recalculateDimensions(selected);
      this.processRotationCenter(selected);
      this.processImageResize(selected);
    } else if (canvasMode === 'multiselect' && !canvas.getSelectedElems().length && !isClickInside && event.target.id === 'svgroot') {
      INKIVE.EditorFacade.trigger('click.outside', {});
    }

    if (!canvas.started) {
      return;
    }

    const pt = svgedit.math.transformPoint(x, y, that.root_sctm);
    const mouseX = pt.x;
    const mouseY = pt.y;
    const mouseTarget = canvas.getMouseTarget(event, pt);
    // retval exists for draw only
    const retval = that.handler.destruct(event, mouseX, mouseY, _retval) || [];
    let [keep, element] = retval;

    /**
     * Trigger dimensions.changed
     * Image, Video resize needs to get dimensions from `$dummyImage`
     * $dummyImage belongs to `resize.js`
     */
    if (canvasMode === 'resize') {
      INKIVE.EditorFacade.trigger('dimensions.changed', { element_id: selected?.id });
    }
    const extResult = canvas.runExtensions('mouseUp', {
      event,
      mouse_target: mouseTarget,
      mouse_x: mouseX,
      mouse_y: mouseY,
      selectedElements: canvas.getSelectedElems()
    }, true);

    this.recalculate(element);

    $.each(extResult, function (i, r) {
      if (r) {
        keep = r.keep || keep;
        element = r.element;
        canvas.started = r.started || canvas.started;
      }
    });

    canvas.validateSelectedElems();
    canvas.call('editor.changed', canvas.getSelectedElems());

    this.trigger('click', event);

    if (selected?.querySelector('.table-cell-selected')) canvas.setMode('table-edit');

    switch (canvas.getMode()) {
      // case 'multiselect':
      case 'select':
        // case 'zoom':
        // case 'resize':
        return;
    }

    const isDrawing = _.includes(['fhpath', 'square', 'rect', 'ellipse', 'circle', 'line'], canvas.getMode());
    const isElementOutsideCanvas =
      !INKIVE.Helpers.isElementInCanvas(element) &&
      !INKIVE.Helpers.isElementPartiallyInCanvas(element);

    if ((!keep && element != null) || (isDrawing && isElementOutsideCanvas)) {
      canvas.getCurrentDrawing().releaseId(canvas.getId());
      element.parentNode.removeChild(element);
      element = null;

      let t = event.target;

      if (isDrawing) {
        canvas.setMode('select');
        $('#workarea').css('cursor', 'auto');

        if (isClickInside) {
          let $clickedElement = $(document.elementFromPoint(x, y));

          if (!$clickedElement.is('.element')) {
            $clickedElement = $clickedElement.parents('.element');
          }

          canvas.selectOnly($clickedElement);
        }
      }

      if (!t.parentNode) return;

      // if this element is in a group, go up until we reach the top-level group
      // just below the layer groups
      // TODO: once we implement links, we also would have to check for <a> elements

      while (t.parentNode.parentNode.tagName === 'g') {
        t = t.parentNode;
      }

      // if we are not in the middle of creating a path, and we've clicked on some shape,
      // then go to Select mode.
      // WebKit returns <div> when the canvas is clicked, Firefox/Opera return <svg>
      if ((canvas.getMode() !== 'path') &&
        t.parentNode.id !== 'selectorParentGroup' &&
        t.id !== 'svgcanvas' && t.id !== 'svgroot') {
        // switch into 'select' mode if we've clicked on an element
        canvas.setMode('select');
        canvas.selectOnly([t], true);
      }
    } else if (element != null) {
      canvas.addedNew = true;
      element.setAttribute('opacity', canvas.cur_properties.opacity);
      element.setAttribute('style', 'pointer-events:inherit');
      svgedit.utilities.cleanupElement(element);
      if (canvas.getMode() === 'path') {
        canvas.pathActions.toEditMode(element);
        endDrawing();
      } else if (canvas.curConfig.selectNew && canvas.getMode() !== 'fhpath') {
        endDrawing();
      }

      isDrawing && canvas.call('editor.added', [element]);

      INKIVE.DesignFacade.trigger('draw');
    }
    canvas.startTransform = null;

    function endDrawing () {
      canvas.selectOnly([element], true);
      canvas.setMode('select');
      $('#workarea').css('cursor', 'auto');
    }
    canvas.startTransform = null;
  }

  recalculate = (function () {
    let element;
    const debouncedRecalculate = _.debounce(recalculate, 600);

    return function (selected) {
      if (element && selected !== element) {
        recalculate();
      }

      element = selected;
      debouncedRecalculate();
    };

    function recalculate () {
      svgedit.recalculate.recalculateDimensions(element);
    }
  })();

  resetObjectDistanceLine (target) {
    const g = document.querySelectorAll('.distanceLineGroup')[0];
    if (!g) return;

    const removeElement = (g, elem, target) => {
      for (let i = 0; i < elem.length; i++) {
        if (elem[i].classList.contains('distance_line_' + target)) {
          g.removeChild(elem[i]);
        }
      }
    };

    if (typeof g !== 'undefined') {
      target
        ? removeElement(g, g.childNodes, target)
        : g.parentNode.removeChild(g);
    }
  }

  handleOutline (target) {
    const isRulersAndGuidesShown = this.canvas.runExtensions(
      'isRulersAndGuidesShown',
      {}
    );

    if (!isRulersAndGuidesShown) return;

    const hoverElement = target && (
      target.closest('g.element.sticker:not(.selected)') ||
      target.closest('g.element.group:not(.selected)') ||
      target.closest('g.element.icon:not(.selected)') ||
      target.closest('g.element.table:not(.selected)') ||
      target.closest('g.element.logo:not(.selected)') ||
      target.closest('g.element.textarea:not(.selected)') ||
      target.closest('a.element.video:not(.selected)') ||
      target.closest('path.element:not(.selected)') ||
      target.closest('ellipse.element:not(.selected)') ||
      target.closest('line.element:not(.selected)') ||
      target.closest('circle.element:not(.selected)') ||
      target.closest('polyline.element:not(.selected)') ||
      target.closest('polygon.element:not(.selected)') ||
      target.closest('rect.element:not(.selected)') ||
      (target.closest('image.element:not(.selected)') && target.closest('image.element:not(.subelement)')));

    if (hoverElement && isRulersAndGuidesShown) {
      let outlineRect = hoverElement.querySelector('.hover-outlined');
      const hasChildNodes = hoverElement.childNodes;
      const isSubElement = hoverElement.classList.contains('subelement');

      if (!outlineRect && hasChildNodes && !isSubElement) {
        const bbox = hoverElement.getBBox();

        outlineRect = this.canvas.addSvgElementFromJson({
          element: 'rect',
          attr: {
            x: bbox.x,
            y: bbox.y,
            width: bbox.width,
            height: bbox.height,
            fill: 'none',
            stroke: '#0BC9F7',
            'stroke-dasharray': '1'
          }
        });

        outlineRect.classList.add('hover-outlined');
        hoverElement.appendChild(outlineRect);
      }
      this.resetObjectDistanceLine();

      const isRotated = coord => {
        return !(coord.x1 === coord.x3 && coord.y1 === coord.y2);
      };

      const getInscribedCoord = selectedCoord => {
        const inscribedCoord = {
          x1: (selectedCoord.x1 + selectedCoord.x2) / 2, // top middle horizontal
          y1: selectedCoord.y1,
          x2: selectedCoord.x2, // right middle vertical
          y2: (selectedCoord.y2 + selectedCoord.y3) / 2,
          x3: selectedCoord.x3, // left middle vertical
          y3: (selectedCoord.y3 + selectedCoord.y1) / 2,
          x4: (selectedCoord.x3 + selectedCoord.x4) / 2, // bottom middle horizontal
          y4: selectedCoord.y3
        };
        return inscribedCoord;
      };

      const handleRotatedElems = (selectedCoord, hoverCoord) => {
        let startPoint, endPoint;
        let minDistance;

        const selectedPoints = coordToPoint(selectedCoord);
        const hoverPoints = coordToPoint(hoverCoord);

        // find two closest points between selected and hover rectangles
        minDistance = Infinity;
        for (let i = 0; i < selectedPoints.length; i++) {
          for (let j = 0; j < hoverPoints.length; j++) {
            const distance = calculateDistance(selectedPoints[i], hoverPoints[j]);
            if (distance < minDistance) {
              minDistance = distance;
              startPoint = selectedPoints[i];
              endPoint = hoverPoints[j];
            }
          }
        }

        return {
          startPoints: [startPoint],
          endPoint
        };
      };

      const handleOffsetElems = (selectedCoord, hoverCoord) => {
        let firstStartPoint, secondStartPoint, endPoint;
        let minDistance;

        // get inscribed coordinates
        selectedCoord = getInscribedCoord(selectedCoord);
        const selectedPoints = coordToPoint(selectedCoord);
        const hoverPoints = coordToPoint(hoverCoord);

        // find the first start point
        minDistance = Infinity;
        for (let i = 0; i < selectedPoints.length; i++) {
          for (let j = 0; j < hoverPoints.length; j++) {
            const distance = calculateDistance(selectedPoints[i], hoverPoints[j]);
            if (distance < minDistance) {
              minDistance = distance;
              firstStartPoint = selectedPoints[i];
              endPoint = hoverPoints[j];
            }
          }
        }

        // find the second start point
        minDistance = Infinity;
        for (let i = 0; i < selectedPoints.length; i++) {
          const distance = calculateDistance(selectedPoints[i], endPoint);
          const isValid = distance < minDistance && selectedPoints[i] !== firstStartPoint;
          if (isValid) {
            minDistance = distance;
            secondStartPoint = selectedPoints[i];
          }
        }

        return {
          startPoints: [firstStartPoint, secondStartPoint],
          endPoint
        };
      };

      const handleNotOffsetElems = (selectedCoord, hoverCoord) => {
        let startPoint, endPoint;
        let minDistance;

        // get inscribed coordinates
        selectedCoord = getInscribedCoord(selectedCoord);
        const hoverPoints = coordToPoint(hoverCoord);

        // determine the start point based on hovered element position
        // since the elements are not offset, only one distance line is drawn
        if (hoverCoord.y3 < selectedCoord.y1) {
          startPoint = [selectedCoord.x1, selectedCoord.y1];
        } else if (hoverCoord.x1 > selectedCoord.x2) {
          startPoint = [selectedCoord.x2, selectedCoord.y2];
        } else if (hoverCoord.y1 > selectedCoord.y4) {
          startPoint = [selectedCoord.x4, selectedCoord.y4];
        } else if (hoverCoord.x2 < selectedCoord.x3) {
          startPoint = [selectedCoord.x3, selectedCoord.y3];
        }

        // end point is the closest point between start point and hovered rectangle
        minDistance = Infinity;
        for (let j = 0; j < hoverPoints.length; j++) {
          const distance = calculateDistance(
            startPoint,
            hoverPoints[j]
          );
          if (distance < minDistance) {
            minDistance = distance;
            endPoint = hoverPoints[j];
          }
        }

        const { xCoord, yCoord } = getCoordXY(hoverCoord);
        const maxX = Math.max(...xCoord);
        const maxY = Math.max(...yCoord);
        const minX = Math.min(...xCoord);
        const minY = Math.min(...yCoord);

        if (startPoint[0] < maxX && startPoint[0] > minX) {
          endPoint[0] = startPoint[0];
        }

        if (startPoint[1] < maxY && startPoint[1] > minY) {
          endPoint[1] = startPoint[1];
        }

        return {
          startPoints: [startPoint],
          endPoint
        };
      };

      const getDistancePoints = (selectedCoord, hoverCoord) => {
        let points;
        if (isRotated(selectedCoord) || isRotated(hoverCoord)) {
          points = handleRotatedElems(selectedCoord, hoverCoord);
        } else {
          points = isOffset(selectedCoord, hoverCoord)
            ? handleOffsetElems(selectedCoord, hoverCoord)
            : handleNotOffsetElems(selectedCoord, hoverCoord);
        }
        return points;
      };

      const getCoordXY = coord => {
        const xCoord = [coord.x1, coord.x2, coord.x3, coord.x4];
        const yCoord = [coord.y1, coord.y2, coord.y3, coord.y4];

        return {
          xCoord,
          yCoord
        };
      };

      const coordToPoint = coord => {
        const points = [
          [coord.x1, coord.y1],
          [coord.x2, coord.y2],
          [coord.x4, coord.y4],
          [coord.x3, coord.y3]
        ];
        return points;
      };

      const calculateDistance = (point1, point2) => {
        const xDistance = point1[0] - point2[0];
        const yDistance = point1[1] - point2[1];
        return Math.sqrt(xDistance ** 2 + yDistance ** 2);
      };

      const isOverlap = (coordA, coordB) => {
        // Check intersection between 2 rotated rectangles
        // https://stackoverflow.com/questions/10962379/how-to-check-intersection-between-2-rotated-rectangles
        const pointsA = coordToPoint(coordA);
        const pointsB = coordToPoint(coordB);
        const recs = [pointsA, pointsB];

        for (let index = 0; index < recs.length; index++) {
          const rec = recs[index];
          for (let i = 0; i < rec.length; i++) {
            const j = (i + 1) % rec.length;
            const p1 = rec[i];
            const p2 = rec[j];
            const normal = { x: p2[1] - p1[1], y: p1[0] - p2[0] };

            let minA = null;
            let maxA = null;
            pointsA.forEach(p => {
              const projected = normal.x * p[0] + normal.y * p[1];
              if (minA === null || projected < minA) minA = projected;
              if (maxA === null || projected > maxA) maxA = projected;
            });

            let minB = null;
            let maxB = null;
            pointsB.forEach(p => {
              const projected = normal.x * p[0] + normal.y * p[1];
              if (minB == null || projected < minB) minB = projected;
              if (maxB == null || projected > maxB) maxB = projected;
            });

            if (maxA < minB || maxB < minA) {
              return false;
            }
          }
        }
        return true;
      };

      const isOffset = (selectedCoord, hoverCoord) => {
        if (isRotated(selectedCoord) || isRotated(hoverCoord)) return;

        const isOffsetX =
          hoverCoord.x1 > selectedCoord.x2 || hoverCoord.x2 < selectedCoord.x1;
        const isOffsetY =
          hoverCoord.y1 > selectedCoord.y3 || hoverCoord.y3 < selectedCoord.y1;

        return isOffsetX && isOffsetY;
      };

      const getArrLines = (selectedCoord, startPoints, endPoint, hoverCoord) => {
        const arrLines = [];
        for (let i = 0; i < startPoints.length; i++) {
          const startPoint = startPoints[i];

          // if the start point and end point are not in the same axis,
          // then we need an addition connected point to construct distance line
          if (startPoint[0] !== endPoint[0] && startPoint[1] !== endPoint[1]) {
            const connectedPoint1 = [startPoint[0], endPoint[1]];
            const connectedPoint2 = [endPoint[0], startPoint[1]];
            const connectedPoint = validConnectedPoint(connectedPoint1, selectedCoord, startPoint, hoverCoord)
              ? connectedPoint1
              : connectedPoint2;
            const textPosition = getTextPosition(startPoint, connectedPoint);

            arrLines.push(
              {
                x1: startPoint[0],
                y1: startPoint[1],
                x2: connectedPoint[0],
                y2: connectedPoint[1],
                text: [textPosition.textX, textPosition.textY, textPosition.value]
              },
              {
                x1: connectedPoint[0],
                y1: connectedPoint[1],
                x2: endPoint[0],
                y2: endPoint[1]
              }
            );
          } else {
            const textPosition = getTextPosition(startPoint, endPoint);

            arrLines.push({
              x1: startPoint[0],
              y1: startPoint[1],
              x2: endPoint[0],
              y2: endPoint[1],
              text: [textPosition.textX, textPosition.textY, textPosition.value]
            });
          }
        }
        return arrLines;
      };

      const validConnectedPoint = (connectedPoint, selectedCoord, startPoint, hoverCoord) => {
        const selectedPoints = coordToPoint(selectedCoord);

        for (let i = 0; i < selectedPoints.length; i++) {
          const selectedPoint = selectedPoints[i];
          const insideSelectedElem = isInside(connectedPoint, selectedCoord);
          const insideHoveredElem = isInside(connectedPoint, hoverCoord);

          if (startPoint.toString() === selectedPoint.toString()) {
            if (insideSelectedElem || insideHoveredElem) {
              return false;
            }
          } else {
            const collinear = isCollinear(startPoint, selectedPoint, connectedPoint);
            const between = isBetween(startPoint, selectedPoint, connectedPoint);

            if ((collinear && between) || (collinear && insideSelectedElem)) {
              return false;
            }
          }
        }
        return true;
      };

      const isInside = (point, coord) => {
        // the point is outside the rectangle if the sum of 4 small triangles
        // is greater than the area of rectangle
        const elementPoints = coordToPoint(coord);
        const pointA = elementPoints[0];
        const pointB = elementPoints[1];
        const pointC = elementPoints[2];
        const pointD = elementPoints[3];

        const sumArea =
          areaTriangle(pointA, point, pointD) +
          areaTriangle(pointD, point, pointC) +
          areaTriangle(pointC, point, pointB) +
          areaTriangle(pointB, point, pointA);

        const areaRec =
          calculateDistance(pointA, pointB) *
          calculateDistance(pointA, pointD);

        return precision(sumArea, 10000) <= precision(areaRec, 10000);
      };

      const areaTriangle = (point1, point2, point3) => {
        const area = Math.abs(
          (point2[0] * point1[1] - point1[0] * point2[1]) +
          (point3[0] * point2[1] - point2[0] * point3[1]) +
          (point1[0] * point3[1] - point3[0] * point1[1])) / 2;
        return area;
      };

      const isCollinear = (point1, point2, point3) => {
        const collinearX = point1[0] === point2[0] && point1[0] === point3[0];
        const collinearY = point1[1] === point2[1] && point1[1] === point3[1];

        return collinearX || collinearY;
      };

      const isBetween = (point1, point2, point3) => {
        const distance12 = calculateDistance(point1, point2);
        const distance23 = calculateDistance(point2, point3);
        const distance13 = calculateDistance(point1, point3);

        return precision(distance12 + distance23, 10000) === precision(distance13, 10000);
      };

      const precision = (value, defaultPrecision = 10) => {
        return Math.round(value * defaultPrecision) / defaultPrecision;
      };

      const getTextPosition = (startPoint, connectedPoint) => {
        const horizontal = startPoint[1] === connectedPoint[1];
        const smallOffset = 5;
        const largeOffset = 10;
        let textX, textY, value;

        if (horizontal) {
          textY = startPoint[1] - smallOffset;
          textX = startPoint[0] > connectedPoint[0]
            ? startPoint[0] - 2 * largeOffset
            : startPoint[0] + smallOffset;
          value = Math.abs(startPoint[0] - connectedPoint[0]);
        } else {
          textX = startPoint[0] + smallOffset;
          textY = startPoint[1] > connectedPoint[1]
            ? textY = startPoint[1] - smallOffset
            : textY = startPoint[1] + largeOffset;
          value = Math.abs(startPoint[1] - connectedPoint[1]);
        }

        return {
          textX,
          textY,
          value
        };
      };

      const addText = (lineText, rulerFactor) => {
        const zoom = this.canvas.getZoom();
        const rcr = document.querySelectorAll('#svgroot')[0].getBoundingClientRect();
        const ccr = document.querySelectorAll('#canvasBackground')[0].getBoundingClientRect();

        const offsetX = ccr.left - rcr.left;
        const offsetY = ccr.top - rcr.top;

        const textX = lineText[0];
        const textY = lineText[1];
        let value = lineText[2] / zoom;

        const text = this.canvas.addSvgElementFromJson(
          {
            element: 'text',
            attr: {
              'font-size': 10,
              fill: '#FF6565',
              x: textX + offsetX,
              y: textY + offsetY
            }
          },
          distanceLineGroup
        );

        if (units !== 'px') {
          value = INKIVE.Helpers.convertPixelsToUnits(value, units) / rulerFactor;
        }

        text.textContent = precision(value);
      };

      const addArrLine = (arrLine, distanceLineGroup, rulerFactor) => {
        const rcr = document.querySelectorAll('#svgroot')[0].getBoundingClientRect();
        const ccr = document.querySelectorAll('#canvasBackground')[0].getBoundingClientRect();

        const offsetX = ccr.left - rcr.left;
        const offsetY = ccr.top - rcr.top;

        for (let i = 0; i < arrLine.length; i++) {
          this.canvas.addSvgElementFromJson(
            {
              element: 'line',
              attr: {
                class: 'distance_line_' + id,
                stroke: arrLine[i].stroke ? arrLine[i].stroke : '#FF6565',
                'stroke-width': '1',
                'pointer-events': 'none',
                'stroke-dasharray': '5 3',
                x1: arrLine[i].x1 + offsetX,
                y1: arrLine[i].y1 + offsetY,
                x2: arrLine[i].x2 + offsetX,
                y2: arrLine[i].y2 + offsetY

              }
            },
            distanceLineGroup
          );

          (arrLine[i].text) && addText(arrLine[i].text, rulerFactor);
        }
      };

      const selectedElems = Array.from(this.canvas.getSelectedElems());
      const hoverCoord = INKIVE.Helpers.getHoveredCoordinates(hoverElement, this.canvas.getZoom());
      const selectedCoord = getSelectedCoordinates(selectedElems);

      if (!selectedCoord) return;

      //  if the elements overlap, do not show the vertical or horizontal distance
      if (isOverlap(selectedCoord, hoverCoord)) return;

      const points = getDistancePoints(selectedCoord, hoverCoord);
      const startPoints = points.startPoints;
      const endPoint = points.endPoint;

      const arrLine = getArrLines(selectedCoord, startPoints, endPoint, hoverCoord);
      const id = selectedElems[0].getAttribute('id');
      const format = INKIVE.Helpers.getInlineSize();
      const units = format.unit;
      const rulerFactor = this.canvas.contentW / INKIVE.Helpers.convertUnitsToPixels(format.width, format.unit);
      const distanceLineGroup = document.querySelectorAll('.distanceLineGroup').length
        ? document.querySelectorAll('.distanceLineGroup')[0]
        : this.canvas.addSvgElementFromJson(
          {
            element: 'g',
            curStyles: false,
            attr: {
              id: this.canvas.getNextId(),
              class: isRulersAndGuidesShown
                ? 'distanceLineGroup'
                : 'distanceLineGroup hidden'
            }
          },
          document.querySelectorAll('#svgpanel')[0]
        );

      $(distanceLineGroup).insertBefore(document.querySelector('#selectorParentGroup'));
      addArrLine(arrLine, distanceLineGroup, rulerFactor);
    } else {
      const hoverOutlinedElements = document.querySelectorAll('.hover-outlined');

      if (!hoverOutlinedElements.length) return;

      hoverOutlinedElements.forEach((e) => e.remove());
      this.resetObjectDistanceLine();

      const selectedElements = this.canvas.getSelectedElems();
      const selectedElement = selectedElements.length ? selectedElements[0] : null;

      if (!selectedElement || selectedElements.length > 1) return;

      const selector = this.canvas.selectorManager.requestSelector(selectedElement);

      selector.reset(selectedElement);
      selector.showGrips(true);
    }
  }
}
